// `updateProjektMetadata` meldet Fehler in der Antwort (`item.error`), nicht als Ausnahme.
// Seit der Längenprüfung (Projekt.metadata = varchar(5000)) kommt so auch „zu lang“
// zurück — ohne diese Prüfung würde die Oberfläche „gespeichert“ melden, obwohl nichts
// geschrieben wurde. `OutdatedVersion` zählt nicht: mit `forceOverwrite` wird trotzdem
// geschrieben, dann ist `item` gesetzt.
export const assertProjectMetadataSaved = (result: unknown): void => {
    const payload = (result as any)?.data?.app?.item;
    if (payload?.item) return;
    throw new Error(payload?.error?.message || 'Projekt-Metadaten wurden nicht gespeichert.');
};
